// Local imports
import React, { useState } from 'react';
import { Alert, Box, Button, Container,TextField, Typography } from '@mui/material';
import { NewPasswordForm, NewPasswordSchema } from '../../services/api/models';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Form, useLocation, useNavigate } from 'react-router-dom';
import { confirmSignIn, ConfirmSignInOutput } from 'aws-amplify/auth';

// Component definition
function NewPasswordPage() {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const location = useLocation();
  const navigate = useNavigate();

  const from = location.state?.from?.pathname || '/search';  // Default to search page if no state

  const methods = useForm<NewPasswordForm>({
      resolver: zodResolver(NewPasswordSchema), // Apply the zodResolver
      defaultValues: {},
    });
    const {
      register,
      handleSubmit,
    } = methods;

  const onSubmit = async (form: NewPasswordForm) => {
    try {
      console.log('new password');
      await confirmSignIn({
        challengeResponse: form.password,
      }).then((result: ConfirmSignInOutput) => {
        console.log(result);
        switch(result.nextStep.signInStep) {
          case 'DONE':
            navigate(from, { replace: true });
            break;
          default:
            navigate('/login');
            break;

        }
      }).catch((error: Error) => {
        setErrorMessage(error.message);
      });

    } catch (error: unknown) {
      console.log(error);
    }
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h2" gutterBottom>
          Enter a new password
        </Typography>

        {errorMessage && (
          <Alert severity="error" sx={{ mt: 2, width: '100%' }}>
            {errorMessage}
          </Alert>
        )}

        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ mt: 1, width: '100%' }}>
              <TextField
                margin="normal"
                required
                fullWidth
                label="New Password"
                type="password"
                autoComplete="new-password"
                {...register('password')}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Reset Password
              </Button>
            </Box>
          </Form>
        </FormProvider>
      </Box>
    </Container>
  )
}

// Default export
export default NewPasswordPage;
